
import {useEffect, useState} from "react";
import {Table, Tag} from "antd";

const columns = [
    {
        title: 'Key',
        dataIndex: 'key',
    },
    {
        title: 'Value',
        dataIndex: 'value',
    },
];

function QueryTabTable(props) {


    useEffect(() => {

    }, []);

    return (
        <Table pagination={{hideOnSinglePage:true}} dataSource={props.query} columns={columns}/>
    );
}

export default QueryTabTable;
